import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class LayoutService {
    readonly isSplashMode = signal(false);

    setSplashMode(active: boolean): void {
        this.isSplashMode.set(active);
    }
}
